import { render, staticRenderFns } from "./AddPrefix.vue?vue&type=template&id=8ba07b6c&scoped=true"
import script from "./AddPrefix.vue?vue&type=script&lang=js"
export * from "./AddPrefix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba07b6c",
  null
  
)

export default component.exports